module.exports = __webpack_public_path__ + "img/icon-08.ea98179f.svg";